<template lang="html">

  <section class="degustacion-quesos row-center ais banner-child-vive animation" :id="$t('banners_experiencia.degustacion-quesos.id')">

    <div class="texto column-center">
      <div class="container -half">
        <h2 class="title -black" v-html="$t('banners_experiencia.degustacionQuesos.titulo')"></h2>
        <p v-html="$t('banners_experiencia.degustacionQuesos.cuerpo')"></p>
      </div>
    </div>

    <div class="imagen">
      <article class="banner-degustacion-quesos row-center plum-border -white -xl">
        <router-link :to="$t('enlaces.degustacionQuesos')" class="enlace-cover"></router-link>
        <router-link :to="$t('enlaces.degustacionQuesos')" class="btn">
          <span v-html="$t('banners_experiencia.degustacionQuesos.boton')"></span>
        </router-link>
      </article>
    </div>

  </section>

</template>

<script lang="js">
 export default  {
  name: 'banner-degustacion-quesos',
}
</script>

<style scoped lang="scss">

@import "@/assets/css/colors.scss";

.degustacion-quesos{
  width: 100%;
  background: white;
}

p{
  text-align: justify;
}

.texto{
  background: white;
  color: black;
}

.title{
  color: black;
}

.degustacion-quesos > div{
  width: 50%;
}

@media screen and (max-width: 1023px){
  .degustacion-quesos > div{
  width: 100%;
  height: auto;
 padding: 50px 25px;
  &.texto{
    padding: 50px 0 0 0;
    order: -1;
  }
}
}

</style>



// WEBPACK FOOTER //
// src/components/parts/banner-degustacion-quesos.vue